export const kycRoutes = {
  basePath: 'kyc',
  fullPath: '/kyc',
  userInfoSlug: {
    basePath: 'user-info',
    fullPath: '/kyc/user-info',
  },
  introSlug: {
    basePath: 'intro',
    fullPath: '/kyc/intro',
  },
  startSlug: {
    basePath: 'start',
    fullPath: '/kyc/start',
  },
  waitingResultsSlug: {
    basePath: 'waiting-results',
    fullPath: '/kyc/waiting-results',
  },
  successSlug: {
    basePath: 'success',
    fullPath: '/kyc/success',
  },
  downloadIdnow2: {
    basePath: 'download-idnow2',
    fullPath: '/download-idnow2',
  },
} as const;
